export default {"src":"/_next/static/media/relationship.622e2fc2.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};